import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.95842 9.1665H10.0001L10.0001 13.5415M17.7084 9.99984C17.7084 14.257 14.2573 17.7082 10.0001 17.7082C5.74289 17.7082 2.29175 14.257 2.29175 9.99984C2.29175 5.74264 5.74289 2.2915 10.0001 2.2915C14.2573 2.2915 17.7084 5.74264 17.7084 9.99984Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.99992 6.125C9.70076 6.125 9.45825 6.36751 9.45825 6.66667C9.45825 6.96582 9.70076 7.20833 9.99992 7.20833C10.2991 7.20833 10.5416 6.96582 10.5416 6.66667C10.5416 6.36751 10.2991 6.125 9.99992 6.125Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.25"
    }, null, -1)
  ])))
}
export default { render: render }